import styled from "styled-components"
import H3 from "../H3"

const Title = styled(H3)`
  margin-bottom: 0;
`
export default Title
